import { View, type StyleProp, type ViewStyle } from "react-native";
import { colors } from "../theme/tokens";

type Props = {
  count: number;
  activeIndex: number;
  accessibilityLabel?: string;
  style?: StyleProp<ViewStyle>;
};

/** Shared position indicator for horizontally paged content. */
export function Carousel({
  count,
  activeIndex,
  accessibilityLabel,
  style,
}: Props) {
  if (count <= 0) return null;

  const selectedIndex = Math.min(Math.max(activeIndex, 0), count - 1);

  return (
    <View
      accessibilityRole="text"
      accessibilityLabel={accessibilityLabel}
      style={[{ flexDirection: "row", gap: 6, alignItems: "center" }, style]}
    >
      {Array.from({ length: count }, (_, index) => (
        <View
          key={index}
          style={{
            width: index === selectedIndex ? 18 : 6,
            height: 6,
            borderRadius: 3,
            backgroundColor:
              index === selectedIndex
                ? colors.softBrown
                : colors.softBrownLight,
            opacity: index === selectedIndex ? 1 : 0.4,
          }}
        />
      ))}
    </View>
  );
}

export default Carousel;
